import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { AppSettings } from './../../modules/shared/app.settings';
import { UserCommonService } from './../../modules/shared/services/user-common.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UiService } from '../../modules/shared/services/ui.service';
import { StorageService } from './../../modules/shared/services/storage.service';
import { CommonBindingDataService } from '../../modules/shared/services/common-binding-data.service';
import { SidebarService } from '../../modules/shared/services/sidebar.service';
import { Message } from 'primeng/components/common/api';

@Component({
  selector: 'app-v1-sign-in',
  templateUrl: './v1-sign-in.component.html'
})
export class V1SignInComponent implements OnInit {

  message: Message[] = [];
  forgotPopup = false;
  loginErrors = {
    username: '',
    password: {
      hasError: false,
      error: []
    },
    general: {
      hasError: false,
      error: []
    }
  };
  subscription: Subscription;
  isSubmitted = false;

  signInForm = new FormGroup({
    username: new FormControl(),
    password: new FormControl()
  });

  constructor(
    private formBuilder: FormBuilder,
    private uiService: UiService,
    private signInService: UserCommonService,
    private translate: TranslateService,
    private router: Router,
    private storageService: StorageService,
    private commonBindingDataService: CommonBindingDataService,
    private sidebarService: SidebarService,
    private userCommonService: UserCommonService
  ) { }

  ngOnInit() {
    const apiToken = this.storageService.getItem(AppSettings.TOKEN_KEY);
    if (apiToken !== undefined && apiToken !== null) {
      const user: any = this.storageService.getItem(AppSettings.USER_DETAILS);
      this.userCommonService.getV1UserProfile(user.id).subscribe(results => {
        this.storageService.setItem(AppSettings.USER_DETAILS, results);
        AppSettings.USER = results;
        this.router.navigate(['/admin-dashboard']);
      }, (error) => {
        console.log(error);
      });
    }
    this.signInForm = this.formBuilder.group({
      password: ['', [Validators.required]],
      username: ['', [Validators.required]],
    });
  }

  onAPIValidation(error) {

    if (error.general) {
      this.loginErrors.general.hasError = true;
      this.loginErrors.general.error = error.general;
    } else if (error.password) {
      this.loginErrors.password.hasError = true;
      this.loginErrors.password.error = error.password;
    }
  }

  doSignIn() {
    const userName = this.signInForm.controls.username.value;
    let data = {};
    if (userName.match(AppSettings.EMAIL_PATTERN)) {
      data = {
        'email': this.signInForm.controls.username.value,
        'password': this.signInForm.controls.password.value,
        'tenantId': AppSettings.TENANT
      };
    } else {
      data = {
        'username': this.signInForm.controls.username.value,
        'password': this.signInForm.controls.password.value,
        'tenantId': AppSettings.TENANT
      };
    }

    this.userCommonService.v1signIn(JSON.stringify(data)).subscribe(results => {
      if (results !== undefined && results.sessionToken !== undefined) {
        this.storageService.setItem(AppSettings.TOKEN_KEY, results.sessionToken);
        this.storageService.setItem(AppSettings.USER_DETAILS, results.user);
        AppSettings.HEADER_AUTHORIZATION_VALUE = results.sessionToken;
        AppSettings.USER = results.user;
        if (results.user.userDetails !== null) {
          this.storageService.setItem('CurrentUsersCorporateId', results.user.userDetails.corporateId);
        }
      }

      this.commonBindingDataService.getServiceTypeOnLogin().subscribe(serviceResults => {
        this.storageService.setItem(AppSettings.SERVICE_TYPE, serviceResults);
        AppSettings.roles.forEach(element => {
          if (element.roleCode === results.user.roles[0].roleCode) {
            AppSettings.LOGGED_IN_ROLE = results.user.roles[0].roleCode;
            this.uiService.profileUpdated();
            this.router.navigate([element.redirect]);
          }
        });

        if (AppSettings.LOGGED_IN_ROLE === '') {
          this.storageService.removeAll();
          const error = {
            general: [
              { message: 'Invalid login credentials.' }
            ]
          };
          this.onAPIValidation(JSON.stringify(error));
        }

        this.isSubmitted = false;
      }, (error) => {
      });

    }, (error) => {
      this.onAPIValidation(error);
    });
  }

  forgotPassword() {
    this.forgotPopup = true;
  }

  onPopClose(event) {
    this.forgotPopup = false;
  }

  onPopSave(event) {
    this.message = [];
    event.general.forEach(element => {
      this.message = [];
      this.message.push({
        severity: 'success',
        summary: 'Forgot Password.',
        detail: element.message
      });
    });
    this.forgotPopup = false;
  }

  eventHandler(event) {
    if (event.keyCode === 13) {
      this.doSignIn();
    }
  }

}
